export default __webpack_public_path__ + "static/media/logoc.b59f2c1b.png";